// extracted by mini-css-extract-plugin
export default {"top_container":"landscape_top_container__LQYNB","title":"landscape_title__NOVSR","hero":"landscape_hero__0Aqg7","image_container":"landscape_image_container__gTAWp"};